import { io } from "socket.io-client";

// Hardcoded chat service URL
const CHAT_URL =
  process.env.REACT_APP_CHAT_URL || "https://apnamestri-chatsystem.onrender.com";

// Get auth token from localStorage or cookies
const getAuthToken = () => {
  const stored = localStorage.getItem("authToken");
  if (stored) return stored;

  const cookies = document.cookie.split(";");
  for (let c of cookies) {
    const [name, value] = c.trim().split("=");
    if (name === "authToken") return value;
  }
  return null;
};

export const chatSocket = io(CHAT_URL, {
  autoConnect: false,
  withCredentials: true,
  transports: ["websocket", "polling"],
  auth: { token: getAuthToken() },
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
});

chatSocket.on("connect", () =>
  console.log("[Chat] Socket connected:", chatSocket.id)
);
chatSocket.on("connect_error", (err) =>
  console.warn("[Chat] Socket error:", err.message)
);
chatSocket.on("disconnect", (reason) =>
  console.log("[Chat] Disconnected:", reason)
);

export const connectChatSocket = (token) => {
  chatSocket.auth = { token: token || getAuthToken() };
  if (!chatSocket.connected) chatSocket.connect();
};

export const disconnectChatSocket = () => {
  if (chatSocket.connected) chatSocket.disconnect();
};
